import { backendPublicPath } from "@/api/servicePaths";

import FETCHRAW from "../fetchRaw";
import { ChatBubble } from "../message/type";

export const getAITask = ({
  params
}: {
  params: {
    [x: string]: string;
  };
}) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/tasks/"),
    method: "get",
    params
  });
export type getAITaskByIdResponseContent = {
  additional_data: {
    is_auto_execution?: boolean;
    playbook_id?: string;
    playbook_name?: string;
    playbook_cadence?: string;
  };
  chat_history: ChatBubble[];
  context: {};
  created_at: string;
  description: string;
  id: string;
  is_deleted: boolean;
  plan: any[];
  source: string;
  state: string;
  summary: string;
  tenant_id: string;
  title: string;
  type: "INTERACTIVE" | "SINGLE_STEP";
  updated_at: number;
  user_id: string;
  proposedPlan?: any;
  page_src?: string;
  pagesrc_id?: string;
  parent_id?: string;
  marketplace?: number;
};

export type getAITaskByIdResponse = {
  headers: {};
  content: getAITaskByIdResponseContent;
};
export const getAITaskById = (id: string) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/tasks/${id}/`),
    method: "get"
    // serverSideReq: req
  });

export const getTaskList = (params?: { dashboard_context_key?: string }) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/tasks/list/"),
    method: "get",
    params: { limit: "100", ...(params || {}) }
  });

export type actionTask = "EXECUTE" | "STOP" | "RESET" | "PAUSE";
export type bodyActionType = {
  action: actionTask;
  comment: string;
  additional_data: any;
};
export type ChangeActionTaskResponseType = {
  content: {
    // last_message_timestamp: string;
    task_id: string;
    // user_input_allowed: true;
    // result: {
    details: {
      details: string;
      grpcStatusCode?: number;
    };
  };
};
export const changeActionTask = (taskId: string, body: bodyActionType) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/tasks/${taskId}/actions/`),
    body: JSON.stringify(body),
    method: "post"
  });
export const changeActionTaskV2 = (url: string, body: bodyActionType) =>
  FETCHRAW({
    type: "apiurl",
    path: url,
    body: JSON.stringify(body),
    method: "post"
  });
export const deleteTask = (taskId: string) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/tasks/${taskId}/`),
    method: "delete"
  });
export type taskUpdateType = {
  title: string;
  description: string;
};
export const updateTask = (taskId: string, body: taskUpdateType) =>
  FETCHRAW({
    type: "apiurl",
    path: backendPublicPath(`/tasks/${taskId}/`),
    body: JSON.stringify(body),
    method: "put"
  });
